import { useState, useEffect } from 'react';
import './BrandsDropdownMobile.scss';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import useCategoryStore from '../../../store/categoryStore';
interface BrandsDropdownMobileProps {
    setIsOpen : (isOpen : boolean) => void;
}
const BrandsDropdownMobile = ({setIsOpen}:BrandsDropdownMobileProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { brands, getBrands } = useCategoryStore();
  const navigate = useNavigate();

  useEffect(() => {
    getBrands();
  }, [getBrands]);

  const toggleBrands = () => {
    setIsExpanded(!isExpanded);
  };

  const handleBrandClick = (brand) => {
    navigate(`/products?b=${brand.id}`);
    setIsOpen(false);
  };

  return (
    <div className="mobile-brands-dropdown">
      <div className="brands-header" onClick={toggleBrands}>
        <span className="brands-title">Brands</span>
        <span className="brands-arrow">
          <FontAwesomeIcon 
            icon={isExpanded ? faChevronDown : faChevronRight} 
          />
        </span>
      </div>

      <div className={`brands-list ${isExpanded ? 'expanded' : ''}`}>
        {brands.map((brand) => (
          <div
            key={brand.id}
            className="brand-item"
            onClick={() => handleBrandClick(brand)}
          >
            {brand.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandsDropdownMobile;